// extracted by mini-css-extract-plugin
export default {"cls1":"CookieConsent-CloseIcon_cls1__LysIl","cls2":"CookieConsent-CloseIcon_cls2__Z1TVx CookieConsent-CloseIcon_cls1__LysIl"};